import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=9eb23d22&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb23d22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/blau-weiss-buchholz/wp-content/plugins/arv-integration-italicbold/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9eb23d22')) {
      api.createRecord('9eb23d22', component.options)
    } else {
      api.reload('9eb23d22', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=9eb23d22&scoped=true&", function () {
      api.rerender('9eb23d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/dev/vue/ResetPassword.vue"
export default component.exports